import React, { FunctionComponent, ReactNode } from 'react';
import List from '../../../components/list/List';

export interface ListItemRendererProps {
  children: ReactNode,
}

const ListItemRenderer: FunctionComponent<ListItemRendererProps> = ({ children }) => (
  <List.Item>
    {children}
  </List.Item>
);

export default ListItemRenderer;
